import React, { useMemo } from 'react'
import { get } from 'lodash'
// import ReactPlayer from 'react-player'
// import LazyLoad from 'react-lazyload'
// import { RichText } from 'prismic-reactjs'
// import { linkResolver } from '@prismicio/gatsby-source-prismic-graphql'
// import '../../../node_modules/uikit/dist/js/uikit.js'
// import { useWindowSizes } from '@hooks/window'
// import { Waypoint } from 'react-waypoint'
// import LogoImg from '../../images/logo.svg'
import Image from './Image'
import { useWindowSizes } from '@hooks/window'

const FarmHeader = ({ data, index, isFarmPage }) => {

  const { isIpadPro, isIpad, isIphonePlus, isDesktop } = useWindowSizes()

  // console.log('[FarmHeader.js] data', data)


  const fazenda_name = useMemo(() => (
    get(data, 'title[0].text', 'title placeholder')
  ), [data])

  const country_name = useMemo(() => (
    get(data, 'country.title[0].text', 'title placeholder')
  ), [data])

  const country_flag = useMemo(() => (
    get(data, 'country.flag')
  ), [data])

  const characteristics = useMemo(() => (
    get(data, 'characteristics')
  ), [data])

  const characteristics_container_class = characteristics?.length > 4 ? ' farm_header__head__specs-scroll' : ''

  // console.log('characteristics', characteristics)

  const main_image = useMemo(() => (
    get(data, 'main_image')
  ), [data])

  let farm_class = ""
  if (isFarmPage === true) {
    farm_class = " farm_header-full_height"
  }

  // // Image size
  // let imgWidth = 1920
  // isIphonePlus  ? imgWidth = 414 :
  // isIpad        ? imgWidth = 768 :
  // isIpadPro     ? imgWidth = 1024 :
  // isDesktop     ? imgWidth = 1440 :
  // imgWidth = 1920

  const renderCharacteristic = (characteristic, index) => {
    
    const characteristic_title = get(characteristic, 'title1[0].text')
    const characteristic_text = get(characteristic, 'text[0].text')

    return (
      <div className="farm_header__head__specs__item" key={index}>
        <label>{characteristic_title}</label>
        <p className="font-book p-medium">
          {characteristic_text}
        </p>
      </div>
    )
  }

  return(
    <section
      key={index}
      className={"farm_header"+farm_class}>
      
      <div className="farm_header__container">

        <div className="row">
          
            <div className="farm_header__head">
              <h2 className="h2 special-font">
                {/* {title} */}
                {fazenda_name}
              </h2>
              <div>
                <div className="country_tag">
                  <img src={country_flag?.url} alt={country_flag?.alt ?? country_name} />
                    {country_name}
                </div>
                {/* <h1 className="h4 farm_header__head__title">
                  {fazenda_name}
                </h1> */}
              </div>
            </div>
        
        


            {characteristics?.length > 0 ? 
            <div className={"farm_header__head__container_specs"+characteristics_container_class}>
              <div className="fazenda_detail_container">
          
                  {characteristics && characteristics?.map((characteristic, index) => (
                    renderCharacteristic(characteristic, index)
                  ))}
         
              </div>
            </div>
          : null}

          
        </div>

        

      </div>

      <div className="farm_header__background">
        {/* <img src={main_image?.url} alt={main_image?.alt && fazenda_name} /> */}
        <Image image={main_image} height={'full'} />
      </div>
      
    </section>
  )  
}

export default FarmHeader
